import { useEffect, useState } from "react";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { Tooltip as ReactTooltip } from "react-tooltip";
import optionsIcon from "../images/svg/optionsIcon.svg";
import Button from "./Button";

const ShippingCards = ({
  openModal,
  onClick,
  title,
  visibility,
  type,
  loading = false,
}) => {
  const [visibilityList, setVisibilityList] = useState("");

  const container = {
    display: "flex",
    flexDirection: "column",
    gap: "18px",
    width: "319px",
    padding: "20px",
    border: "1px solid #D7D7D7",
    borderRadius: "10px",
    backgroundColor: "#fff",
  };

  const boxLineCard = {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  };

  const formactVisibility = () => {
    if (typeof visibility !== "string" && visibility?.length > 0) {
      const newVisibility = visibility.map((item) => item.corporate_name);
      setVisibilityList(newVisibility.join(", "));
    } else if (typeof visibility === "string") {
      setVisibilityList("Todos");
    }
  };

  useEffect(() => {
    formactVisibility();
  }, [visibility]);

  return (
    <div style={container}>
      <div style={boxLineCard}>
        {loading ? (
          <Skeleton width={200} height={20} />
        ) : (
          <p
            className="textTitleShippingCard"
            data-tooltip-id="title"
            data-tooltip-content={title}
            data-tooltip-place="top"
            data-tooltip-position-strategy="fixed"
          >
            {title}
          </p>
        )}

        {loading ? (
          <Skeleton circle width={24} height={24} />
        ) : (
          <>
            <img
              onClick={openModal}
              style={{ cursor: "pointer" }}
              src={optionsIcon}
              alt="Options"
            />
            <ReactTooltip id="title" />
          </>
        )}
      </div>

      <div
        style={{
          ...boxLineCard,
          borderTop: "1px solid #d7d7d7",
          paddingTop: "20px",
        }}
      >
        <p className="textTypeShippingCard">Tipo</p>
        {loading ? (
          <Skeleton width={120} height={18} />
        ) : (
          <p className="textTypeValueShippingCard">{type}</p>
        )}
      </div>

      <div style={boxLineCard}>
        <p className="textTypeShippingCard">Visibilidade</p>
        <div style={{ width: "143px", overflow: "hidden" }}>
          {loading ? (
            <Skeleton width={140} height={18} />
          ) : (
            <p
              className="textTypeValueShippingCardPoints"
              data-tooltip-id="visibility"
              data-tooltip-content={visibilityList}
              data-tooltip-place="top"
              data-tooltip-position-strategy="fixed"
            >
              {visibilityList}
            </p>
          )}
          <ReactTooltip id="visibility" />
        </div>
      </div>

      {loading ? (
        <Skeleton width="100%" height={37} borderRadius={60} />
      ) : (
        <Button
          width="100%"
          height="37px"
          background={"var(--color-primary)"}
          borderRadius="60px"
          marginTop="0"
          name="Ver Detalhes"
          color={"var(--white)"}
          onClick={onClick}
          border="none"
        />
      )}
    </div>
  );
};

export default ShippingCards;
